var map = {
	"./angular.svg": [
		55,
		3
	],
	"./aws.svg": [
		56,
		4
	],
	"./azure-pipelines.svg": [
		57,
		5
	],
	"./azure.svg": [
		58,
		6
	],
	"./bootstrap.svg": [
		59,
		7
	],
	"./close.svg": [
		60,
		8
	],
	"./contentful.svg": [
		61,
		9
	],
	"./docker.svg": [
		62,
		10
	],
	"./github-actions.svg": [
		63,
		11
	],
	"./github.svg": [
		64,
		12
	],
	"./java.svg": [
		65,
		13
	],
	"./linkedin.svg": [
		66,
		14
	],
	"./mysql.svg": [
		67,
		15
	],
	"./npm.svg": [
		68,
		16
	],
	"./php.svg": [
		69,
		17
	],
	"./project-logo.svg": [
		70,
		18
	],
	"./react.svg": [
		71,
		19
	],
	"./sass.svg": [
		72,
		20
	],
	"./search.svg": [
		73,
		21
	],
	"./settings.svg": [
		74,
		22
	],
	"./spotify.svg": [
		75,
		23
	],
	"./stencil.svg": [
		76,
		24
	],
	"./storybook.svg": [
		77,
		25
	],
	"./twitter.svg": [
		78,
		26
	],
	"./typescript.svg": [
		79,
		27
	],
	"./web-components.svg": [
		80,
		28
	],
	"./webpack.svg": [
		81,
		29
	],
	"./yarn.svg": [
		82,
		30
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 51;
module.exports = webpackAsyncContext;